import React, { useEffect, useState } from 'react'
import Link from 'next/link'
import Image from 'next/image'
import SectionHeading from '../../Common/SectionHeading'
import CommonPopup from '../../../components/PopupForm/CommonPopup';
import * as Yup from 'yup';

export default function OurUniqueSection({data=null, endpoint='/enquiry/get-expert-cis'}) {
    
  const [DataRendered, setDataRendered] = useState(false);
  useEffect(()=>{
    setDataRendered(true)
  },[])
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => {
    setIsModalOpen(true);
  };
  
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const options = {
    btn_name: "Submit"
  }

  const phoneRegExp = /^(\+\d{1,4})?(\d{9,14})$/

  const fields = [
    {
      name: 'name',
      label: '',
      placeholder: 'Full Name*',
      validation: Yup.string().matches(/^[a-zA-Z\s]*$/, 'Name can only contain letters and spaces').required('Name is required'),
      className:'block text-gray-700 w-full h-auto py-3 border focus:outline-none focus-visible:border border-gray-300 px-4 bg-transparent',
      customClass: 'md:col-span-6 col-span-12'
  },
  {
      name: 'email',
      type: 'email',
      label: '',
      placeholder: 'Add Corporate E-mail ID*',
      validation: Yup.string().email('Invalid email').required('Email is required'),
      className:'block text-gray-700 w-full h-auto py-3 border focus:outline-none focus-visible:border border-gray-300 px-4 bg-transparent',
      customClass: 'md:col-span-6 col-span-12'
  
  },
];

    return (
        <>
            {(data) &&
                <>
                    <section className="w-11/12 xl:max-w-screen max-w-screen-2xl flex flex-col justify-center mx-auto lg:my-10 my-6">
                        <SectionHeading
                            title="Our Unique Value Proposition"
                            
                        />
                        <div className='grid grid-cols-12 gap-4'>
                            {data?.map((item,index) =>(
                                <div key={index} className='md:col-span-4 col-span-12'>
                                    <div className="cursor-pointer relative hover:shadow-lg shadow hover:border-b-2 hover:border-blue-500 hover:-translate-y-2 bg-gray-50 h-full w-full rounded px-6 py-6 hover:transition-all hover:duration-300 hover:ease-out before:absolute before:content-[''] before:w-[25px] before:h-[45px] before:border-l-4 before:border-t-4 before:border-l-[#1b5df3] before:border-t-[#1b5df3] before:left-[-1px] before:top-[-1px] group" onClick={openModal}>
                                        <div className="itemBox p-30 transition-all duration-350 ease-in-out overflow-hidden relative">
                                            <h3 className="text-lg font-semibold">{item?.title}</h3>
                                            <p className='mb-0 text-base'>
                                                {item?.description}
                                            </p>
                                            <p onClick={openModal} className='my-2 cursor-pointer hidden hover:text-[#1b5df3] group-hover:block'>Click to know more <i className='fa fa-arrow-right hidden lg:block pr-6 text-sm group-hover:animation-[ease-in-out] group-hover:animation-[infinite]'></i></p>
                                        </div>
                                    </div>
                                    <CommonPopup isOpen={isModalOpen} closeModal={closeModal} 
                                        fields={fields}
                                        options={options}
                                        page_name="Competitive Intelligence Services"
                                        form_name="schedule-a-meeting"
                                        formTitle="Connect to a Consultant"
                                        endpoint={endpoint}
                                    />
                                </div>
                            ))}
                        </div>
                    </section>
                </>
            }
        </>
    )
}
